// components/ProfileCard.jsx
import { Card, Typography, Space } from "antd";
import {
  UserOutlined,
  BankOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

export const ProfileCard = ({ name, company, location, t }) => {
  return (
    <Card
      title={t("mypage.profile")}
      bordered={false}
      style={{
        borderRadius: 12,
        boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        height: "100%",
      }}
    >
      <Space direction="vertical" size={14}>
        <Space>
          <UserOutlined style={{ color: "#1677ff" }} />
          <Text strong>{name || "-"}</Text>
        </Space>

        <Space>
          <BankOutlined style={{ color: "#1677ff" }} />
          <Text>{company || "-"}</Text>
        </Space>

        <Space>
          <EnvironmentOutlined style={{ color: "#1677ff" }} />
          <Text>{location || "-"}</Text>
        </Space>
      </Space>
    </Card>
  );
};
